module.exports = __webpack_public_path__ + "media/src/images/dandori/step8-402702305e4fb03cff4cb22f6a06aa3c.png";